<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'lista' ? 'active' : ''" @click.prevent="abrir('lista')">
                        Autorizações
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'prorrogacao' ? 'active' : ''" @click.prevent="abrir('prorrogacao')">
                        Prorrogação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'info' ? 'active' : ''" @click.prevent="abrir('info')">
                        Informações
                    </a>
                </li>
            </ul>
        </div>

        <visao-geral-autoriz v-if="aba == 'visao'" />
        <solicitacao-autorizacao v-if="aba == 'lista'" />
        <informacoes v-if="aba == 'info'" />
        <prorrogacao-de-conta v-if="aba == 'prorrogacao'" />
    </div>
</template>

<script>
import VisaoGeralAutoriz from './VisaoGeralAutoriz.vue';
import SolicitacaoAutorizacao from './SolicitacaoAutorizacao.vue';
import ProrrogacaoDeConta from './ProrrogacaoDeConta.vue';
import Informacoes from '../callcenter/Informacoes.vue';

export default {
    data() { 
        return { 
            fluxo: null, 
            tem_intern: false, 
        };
    },

    components: { 
        VisaoGeralAutoriz,
        SolicitacaoAutorizacao, 
        ProrrogacaoDeConta,
        Informacoes
    }, 

    props: ['aba'], 

    beforeMount() { 
        if ( this.$store.state.user.id_usuario == 1 ) { 
            this.tem_intern = true; 
        } else if ( this.$store.state.user && this.$store.state.user.perfil_usuarios ) { 
            this.tem_intern = ( this.$store.state.user.perfil_usuarios.some( p => p.id_perfil == 19 ) ? true : false );
        }
    },

    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/autorizacoes/' + aba });
            }
        },
    },
}
</script>